import * as analyticsApi from '@/api/analytics'

const state = {
  overview: null,
  accounts: [],
  posts: [],
  loading: false,
  syncing: false,
}

const getters = {
  overview: (state) => state.overview,
  accounts: (state) => state.accounts,
  posts: (state) => state.posts,
  loading: (state) => state.loading,
  syncing: (state) => state.syncing,
}

const actions = {
  async fetchOverview({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await analyticsApi.getOverview()
      commit('SET_OVERVIEW', data.data.overview)
      commit('SET_ACCOUNTS', data.data.accounts || [])
      return data.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPosts({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await analyticsApi.listPostAnalytics()
      commit('SET_POSTS', data.data.posts || [])
      return data.data.posts
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async sync({ commit, dispatch }) {
    commit('SET_SYNCING', true)
    try {
      const { data } = await analyticsApi.syncAnalytics()
      await dispatch('fetchOverview')
      await dispatch('fetchPosts')
      return data.data
    } finally {
      commit('SET_SYNCING', false)
    }
  },
}

const mutations = {
  SET_OVERVIEW(state, overview) {
    state.overview = overview
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts
  },
  SET_POSTS(state, posts) {
    state.posts = posts
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_SYNCING(state, syncing) {
    state.syncing = syncing
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
